import { useContext, type ReactElement } from 'react'

import { GTMNoScriptIFrame, GTMScript } from '@lib/tracking/google_tag_manager'
import { SHLegacyTracking } from '@lib/tracking/sh_legacy'

import { PageContext } from '@contexts/page-context'

interface ShPageScriptsProps {
  enableGtmIntegration?: boolean
  enableLegacyTracking?: boolean
}

export function ShPageScripts({
  enableLegacyTracking = false,
  enableGtmIntegration = false,
}: ShPageScriptsProps): ReactElement | null {
  const { isPreview } = useContext(PageContext)

  if (isPreview) {
    return null
  }

  return (
    <>
      {enableLegacyTracking && <SHLegacyTracking />}
      {enableGtmIntegration && <GTMScript />}
      {enableGtmIntegration && <GTMNoScriptIFrame />}
    </>
  )
}
